import script from "./HorizontalItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./HorizontalItem.vue?vue&type=script&lang=ts&setup=true"

import "./HorizontalItem.vue?vue&type=style&index=0&id=4227bde6&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4227bde6"]])

export default __exports__